import React, { useState } from 'react';
import { colors, camelCase } from "../../../constants/constants";
import AlertService from '../../../services/AlertService';
import AssetDetailsModal from './AssetDetailsModal';

const AlertDetails = ({ alertType, alertId, alertSeverity, date, lastUpdated, description, address, unit, alertStatus, alertName, initialChecks, suggestions, deviceData, alertAssetId}) => {
    const [isAssetModalOpen, setIsAssetModalOpen] = useState(false);
    const [assetData, setAssetData] = useState(null);
    const [loadingAsset, setLoadingAsset] = useState(false);
    
    let backgroundColor = colors.primaryColor;
    
    switch (alertSeverity) {
        case 'CRITICAL':
        case 'Critical':
        case 'High': // Legacy: High maps to CRITICAL (Red)
            backgroundColor = colors.alertBackground; // Red for CRITICAL
            break;
        case 'HIGH':
        case 'High': 
        case 'Low': // Legacy: Low maps to HIGH (Yellow)
            backgroundColor = colors.lowBackground; // Yellow for HIGH
            break;
        case 'POTENTIAL':
        case 'Potential':
        case 'None': // Legacy: None maps to POTENTIAL (Green)
            backgroundColor = colors.greenBackground; // Green for POTENTIAL
            break;
        default:
            backgroundColor = colors.primaryColor;
            break;
    }

    // Check for asset ID - prioritize alert.asset, then device.location.asset, then device.asset
    const assetId = alertAssetId || (deviceData?.location?.asset) || (deviceData?.asset);
    const hasAssetId = !!assetId;
    
    const handleViewAssetDetails = async () => {
        if (!hasAssetId) return;
        
        setLoadingAsset(true);
        try {
            const assetDetails = await AlertService.getAssetById(assetId);
            setAssetData(assetDetails);
            setIsAssetModalOpen(true);
        } catch (error) {
            console.error('Failed to fetch asset details:', error);
            alert('Failed to load asset details. Please try again.');
        } finally {
            setLoadingAsset(false);
        }
    };
    
    return (
        <div className='alert-cols'>
            <div className='status-row'>
                {alertSeverity && (
                <div className='alert-row'>
                <div className='alert-title'>Impact</div>
                    <div className='alert-value'><span
                    style={{
                        textTransform: 'none',
                        borderRadius: '10px',
                        backgroundColor: backgroundColor,
                        color: 'white',
                        fontWeight: 'bold',
                        padding: '8px 28px',
                    }}>{camelCase(alertSeverity)}</span></div>
                </div>
                )}
                {alertStatus && (
                    <div className='alert-row'>
                        <div className='alert-title'>Status</div>
                        <div className='alert-value'>{alertStatus}</div>
                    </div> 
                )}   
            </div>  
            {alertName && (
            <div className='alert-row'>
                <div className='alert-title'>Alert</div>
                <div className='alert-value'>{alertName}</div>
            </div>
            )}
            {description && (
            <div className='alert-row'>
                <div className='alert-title'>Description</div>
                <div className='alert-value'>{description}</div>
            </div> 
            )}
            {date && (
            <div className='alert-row'>
                <div className='alert-title'>Date Reported</div>
                <div className='alert-value'>{date}</div>
            </div>    
            )}
            {lastUpdated && (
            <div className='alert-row'>
                <div className='alert-title'>Last Updated</div>
                <div className='alert-value'>{lastUpdated}</div>
            </div>    
            )}
            {address && (   
            <div className='alert-row'>
                <div className='alert-title'>Building</div>
                <div className='alert-value'>{address}</div>
            </div>
            )}
            {unit && (
            <div className='alert-row'>
                <div className='alert-title'>Location</div>
                <div className='alert-value'>{unit}</div>
            </div>
            )}

            {/* Asset Details Section - Check alert.asset first, then device.asset */}
            {hasAssetId && (
            <div className='alert-row'>
                <div className='alert-title'>Asset Information</div>
                <div className='alert-value'>
                    <button 
                        className="asset-details-button"
                        onClick={handleViewAssetDetails}
                        disabled={loadingAsset}
                        style={{
                            backgroundColor: loadingAsset ? '#ccc' : '#5C623D',
                            color: 'white',
                            border: 'none',
                            padding: '10px 20px',
                            borderRadius: '8px',
                            cursor: loadingAsset ? 'not-allowed' : 'pointer',
                            fontWeight: 'bold',
                            fontSize: '14px',
                            transition: 'background-color 0.2s'
                        }}
                        onMouseOver={(e) => {
                            if (!loadingAsset) e.target.style.backgroundColor = '#4a5233';
                        }}
                        onMouseOut={(e) => {
                            if (!loadingAsset) e.target.style.backgroundColor = '#5C623D';
                        }}
                    >
                        {loadingAsset ? 'Loading...' : 'View Asset Details'}
                    </button>
                </div>
            </div>
            )}

            {initialChecks && initialChecks.length > 0 && (
                <div className='alert-row'>
                    <div className='alert-title'>Check These Items</div>
                    <div className='alert-value'>
                        <ul style={{padding: 0}}>
                            {initialChecks.map((check, index) => (
                                <li key={index}>{check}</li>
                            ))}
                        </ul>
                    </div>
                </div>
            )}
            {suggestions && suggestions.length > 0 && (
                <div className='alert-row'>
                    <div className='alert-title'>Is the Issue Still Present?</div>
                    <div className='alert-value'>
                        <ul style={{padding: 0}}>
                            {suggestions.map((suggestion, index) => (
                                <li key={index}>{suggestion}</li>
                            ))}
                        </ul>
                    </div>
                </div>
            )}

            {/* Asset Details Modal */}
            <AssetDetailsModal
                isOpen={isAssetModalOpen}
                onClose={() => setIsAssetModalOpen(false)}
                assetData={assetData}
            />
        </div>
    );
};

export default AlertDetails;